import Header from "./Header";
import Footer from "./Footer";
import { useState } from "react";
import Select from "react-select";
import translatedHeading from "../utils/util";
import "../styles/App.css";


const Events = () => {
  const [selectedYear, setSelectedYear] = useState({
    label: 2025,
    value: 2025,
  });
  const [selectedEvent, setSelectedEvent] = useState({
    value: "holi",
    label: translatedHeading("Holi"),
  });
  const startYear = new Date("2024-01-01").getFullYear();
  const currentYear = new Date().getFullYear();
  const years = Array.from(
    { length: currentYear - startYear + 1 },
    (_, i) => startYear + i
  );
  const yearOptions = years.map((year) => {
    return { value: year, label: year };
  });
  const eventOptions = [
    { value: "holi", label: translatedHeading("Holi") },
    { value: "bhandara", label: translatedHeading("Bhandara") },
    { value: "pad_yatra", label: translatedHeading("Shri Paramhans Dayal Smriti Pad Yatra") },
    { value: "guru_purnima", label: translatedHeading("Guru Purnima") },
    { value: "ganga_dussehra", label: translatedHeading("Ganga Dussehra") },
    { value: "diwali", label: translatedHeading("Diwali") },
  ];
  const customStyles = {
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isSelected ? 'lightgray' : 'white',
    color:  'black',
    '&:hover': {
      backgroundColor: 'rgba(0, 0, 0, 0.1)',
      color: 'black',
    },
  }),
};

  return (
    <>
      <Header />
      <div className="page-header">{translatedHeading("Events")}</div>
      <div className="events">
        <div className="events-dropdowns">
          {translatedHeading("Select year")}
          <Select
            placeholder="Select year"
            value={selectedYear}
            options={yearOptions}
            onChange={(e) => setSelectedYear(e)}
            id="yearSelected"
            required={true}
             styles={customStyles}
          />
        </div>
        <div className="events-dropdowns">
          {translatedHeading("Select event")}
          <Select
            placeholder="Select event"
            value={selectedEvent}
            options={eventOptions}
            onChange={(e) => setSelectedEvent(e)}
            id="eventSelected"
             styles={customStyles}
          />
        </div>
        <button className="event-submit">Submit</button>
      </div>
      <Footer />
    </>
  );
};
export default Events;
